export const container = 'py-4 px-6';
export const icon = '';
export const sectionTitle = 'mt-4 text-normal font-semibold';
export const sectionSubtitle = 'text-xs';
export const inputContainer = 'my-4';
export const inputLabel = 'text-normal font-semibold';
export const inputHint = 'text-sm';
export const textArea = 'my-3';
export const textInputLabel = 'text-sm font-bold';
export const gridContainer = 'grid grid-cols-1 md:grid-cols-2 gap-4';
export const businessLogoContainer = 'flex gap-4 items-center';
export const businessLogo = 'flex justify-center items-center h-28 w-28 rounded-full';
export const businessLogoText = 'text-4xl';
export const cardContainer ="w-4/5"
export const card = 'flex items-center mt-4';
export const hiddenFileInput = 'hidden';
export const fileUploadLabel = 'flex flex-col items-center';
export const uploadIcon = 'h-8 w-8 mb-2';
export const fileUploadText = 'text-sm';
export const fileUploadHint = 'text-xs';
export const socialMediaContainer ="grid grid-cols-1 md:grid-cols-2 gap-4"
export const buttonContainer ="px-10 w-full"
export const button ="bg-custom-button-green"